import { useMutation, useQuery, useQueryClient } from "react-query";

import {
  createDocsAccessCode,
  listDocsAccessCodes,
  revokeDocsAccessCode,
} from "./api";
import type { CreateDocsAccessCodeInput } from "./types";

const docsAccessCodesKey = ["docsAccessCodes"] as const;

export function useDocsAccessCodes() {
  return useQuery(docsAccessCodesKey, listDocsAccessCodes, {
    staleTime: 30_000,
  });
}

export function useCreateDocsAccessCode() {
  const queryClient = useQueryClient();
  return useMutation(
    (input: CreateDocsAccessCodeInput) => createDocsAccessCode(input),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(docsAccessCodesKey);
      },
    },
  );
}

export function useRevokeDocsAccessCode() {
  const queryClient = useQueryClient();
  return useMutation((id: string) => revokeDocsAccessCode(id), {
    onSuccess: () => {
      void queryClient.invalidateQueries(docsAccessCodesKey);
    },
  });
}
